import { EnergyOrb } from "./EnergyOrb";

export const STATE_LABEL = {
  inactivo: "Inactivo", escuchando: "Escuchando", pensando: "Pensando", hablando: "Hablando", interrumpido: "Interrumpido", error: "Error", ejecutando: "Ejecutando", exito: "Completado",
};

export function Orb({ state = "inactivo", size = 260, audioLevel = null }) {
  return <div data-testid="jarvis-orb" data-state={state} role="img" aria-label={`Estado de JARVIS: ${STATE_LABEL[state]||state}`} style={{width:size,height:size}}><EnergyOrb state={state} size={size} audioLevel={audioLevel}/></div>;
}

export function LegacyOrb({ state = "inactivo", size = 260 }) {
  return (
    <div className="orb" data-state={state} style={{ width: size, height: size }} aria-label={`Estado: ${STATE_LABEL[state]}`}>
      <div className="orb-ring" />
      <div className="orb-ring r4" />
      <div className="orb-ring r2" />
      <div className="orb-ring r3" />
      <div className="orb-ping" />
      <div className="orb-ping p2" />
      <div className="orb-core" />
    </div>
  );
}
